export type ExtractPathParams<T extends string> = T extends `${infer _Start}:${infer Param}/${infer Rest}`
  ? { [K in Param | keyof ExtractPathParams<Rest>]: string }
  : T extends `${infer _Start}:${infer Param}`
    ? { [K in Param]: string }
    : {};

export const extractPathParams = <T extends string>(path: string, pattern: T): ExtractPathParams<T> | null => {
  // Удаляем завершающий слэш из пути и шаблона для корректного сравнения
  const normalizedPath = path.replace(/\/$/, ''); // Удаляем завершающий слэш
  const normalizedPattern = pattern.replace(/\/$/, ''); // Удаляем завершающий слэш

  // Преобразуем шаблон в регулярное выражение
  const regexPattern = normalizedPattern.replace(/:\w+/g, '([^/]+)');
  const regex = new RegExp(`^${regexPattern}$`);

  // Проверяем, соответствует ли путь шаблону
  const matchArgs = normalizedPath.match(regex);

  if (!matchArgs) {
    return null;
  }

  // Извлекаем имена параметров из шаблона
  const paramNames = Array.from(pattern.matchAll(/:\w+/g)).map((match) => match[0].slice(1)) as string[];

  // Создаем объект с извлеченными параметрами
  const params = {} as ExtractPathParams<T>;
  paramNames.forEach((name, index) => {
    (params as Record<string, string>)[name] = matchArgs[index + 1];
  });

  return params;
};
